import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { editDTRRule } from 'RestAPIs/dtrRules';

import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

export const useSaveDTRRule = (handleClose: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation(editDTRRule, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['DTRRules', 'list']);
      handleClose();
      showSuccessSnackbar();
    },
    onError: () => {
      showErrorSnackbar(t('saveError', { name: 'DTRRule' }));
    }
  });
};
